import { WerfenColor } from '../../../Constants/ColorChart'; // Adjust the path as necessary

const Exclamation = (props) => {
    return (
        <svg width="22" height="23" viewBox="0 -1 100 100" xmlns="http://www.w3.org/2000/svg">

        <circle cx="50" cy="50" r="45" stroke="#001387" stroke-width="4" fill="none"/>
        <line x1="50" y1="25" x2="50" y2="55" stroke="#001387" stroke-width="4"/>
        <line x1="50" y1="65" x2="50" y2="67" stroke="#001387" stroke-width="4"/>
      </svg>
    );
};

export default Exclamation; 